import React, { useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";
import * as S from '../scss/theme';
import fnc from "../mymod/commFunction";
import './Assess_all_checkList.scss';
import HongButton from "../comm/HongButton";
import { useNavigate } from "react-router-dom";

import Checkbox from '@mui/material/Checkbox';

const Assess_all_checkList = ({testCode, stCode}) => {
    const userInfo = useSelector((state) => state.reduxIgong.userInfo);
    const selectedUserInfo = useSelector((state) => state.reduxIgong.selectedUserInfo);
    const navigate = useNavigate();
    const [list, setList] = useState([]);
    const [selectedItems, setSelectedItems] = useState([]);//체크박스
    const [selectedItemsType, setSelectedItemsType] = useState([]);//체크박스

    useEffect(() => {
        fncQuestion_mamTec();
        console.log(testCode, stCode, 'testCode, stCode');
    }, []);

 
    function fncQuestion_mamTec() {//설문조사 학부모 교사
        const userKind2 = selectedUserInfo.userKind2;
        // alert('userKind2: ' + userKind2)
        let routePath;
        if (userKind2 === '학생') {
            routePath = '/igonAssess_momTecRoutes/select/question_stu_checkList';
        } else {
            routePath = '/igonAssess_momTecRoutes/select/question_momTec_checkList';
        }

        fnc.sendAxios(routePath, {testCode, stCode }, (res) => {
          if (res && res.length > 0) {
           const listRes = getRecords(res);
           setList(listRes);
          } else {
            console.log("속성이 obj 내에 없습니다.");
          }
        });
      }



    function getRecords(res) {
        let records = [];

        for (let i = 0; i < res.length; i++) {      
            const sno= res[i]["sno"];
            const no= res[i]["no"];
            const gpNum2 = res[i]["gpNum2"];
            const gpNum1 = res[i]["gpNum1"];
            const type = res[i]["type"];
            const que = res[i]["que"];
            const value = res[i]["value"];
    
            records.push({ sno, no, gpNum2, type, que, gpNum1, value });
        }
        return records;
      }

 
    //=============================================
    return (
 
            <div className="Assess_all_checkList">
                <div className='wrap-main'>
                <section className='section-list'>
                    
                <table className="table-hong">
                    <thead>
                        <tr>
                            <th>no</th>
                            <th>구분</th>
                            <th>질의내용</th>        
                        </tr>            
                    </thead>
                    <tbody>
                        {list.map((item, i) => {
                            const isFirstOfGroup = i % 2 === 0;
                            const isHighlighted = item.value?.trim() !== ''; // value가 공백이 아닌 경우
                        
                            return (
                            <tr className={item.gpNum1} key={item.sno}>
                                {isFirstOfGroup ? (
                                <td className="no" rowSpan={2}>{item.no}</td>
                                ) : (
                                <td style={{ display: "none" }}></td> // 구조 맞추기용
                                )}
                                <td style={{ color: isHighlighted ? 'red' : 'inherit' }}>{item.type}</td>
                                <td style={{ color: isHighlighted ? 'red' : 'inherit' }}>{item.que}</td>
                
                            </tr>
                            );
                        })}
                    </tbody>
                </table>

                </section>
                </div>
            </div>

    );
};

export default Assess_all_checkList;
